import { appGetState } from 'legacy/lut/store'

import { Nullable } from 'clickNgo/models/utils'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { IFetchQbrDocumentResponse } from '../../models/qbr/IFetchQbrDocumentResponse'

export interface IFetchQbrDocumentParameters {
  documentId: number
  isForceUpdate?: boolean
}

export const fetchQbrDocument = async ({
  documentId,
  isForceUpdate = false,
}: IFetchQbrDocumentParameters): Promise<Nullable<IFetchQbrDocumentResponse>> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPQBRDocument/call`)

  if (documentId) {
    const payload = {
      'p.DocumentID': documentId,
      'p.Force': Number(isForceUpdate),
    }

    const {
      app: { ownerId },
    } = appGetState()

    const [accessToken] = getTokens(ownerId)
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response = await Rest.post({ url, payload, headers })

      return response.Data?.[0] || null
    } catch (e) {
      return null
    }
  }

  return null
}
